import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { useAutoplay } from "../../hooks/useAutoplay";
import { useReducedMotion } from "../../hooks/useReducedMotion";
import { AutoplayContext } from ".";

export const AutoplayProvider = ({ children, config = {} }) => {
  const {
    isLead,
    isLivePreviewEnabled = false,
    isAutoplayOverride,
    autoplayLive = false,
    forceNoLoop,
    isSubscriber = false,
    reduceMotion
  } = config;

  // Disable autoplay, looping, and playthrough if user requests reduced motion
  // https://helpcenter.washingtonpost.com/hc/en-us/articles/13955752562971-How-do-I-turn-off-animations-looping-videos-and-other-motion-on-the-screen-
  const { isMotionReduced, setOverrideReducedMotion } =
    useReducedMotion(reduceMotion);

  const { autoplayState, updateAutoplayState } = useAutoplay({
    isLead,
    isMotionReduced,
    isLivePreviewEnabled,
    isAutoplayOverride,
    autoplayLive,
    forceNoLoop,
    isSubscriber
  });

  const contextValue = useMemo(
    () => ({
      autoplayState,
      updateAutoplayState,
      isMotionReduced,
      setOverrideReducedMotion
    }),
    [
      autoplayState,
      updateAutoplayState,
      isMotionReduced,
      setOverrideReducedMotion
    ]
  );

  return (
    <AutoplayContext.Provider value={contextValue}>
      {children}
    </AutoplayContext.Provider>
  );
};

AutoplayProvider.propTypes = {
  config: PropTypes.object,
  children: PropTypes.node
};
